export default __webpack_public_path__ + "static/assets/e69b327a1b60b153f51df533fe9b6e83.png";